import React, { useState } from 'react';

interface AssessmentContextInterface {
  page: number;
  setPage: (page: number) => void;
}

const AssessmentContext = React.createContext<Partial<AssessmentContextInterface>>({});

const AssessmentProvider = (props: any) => {
  const [page, setPage] = useState(1);

  return (
    <AssessmentContext.Provider
      value={{
        page,
        setPage,
      }}
      {...props}
    />
  );
};

const useAssessment = () => {
  const context = React.useContext(AssessmentContext);
  if (context === undefined) {
    throw new Error('useAssessment must be used within a AssessmentProvider');
  }
  return context as AssessmentContextInterface;
};

export { AssessmentProvider, useAssessment };
